import stickermaker from './stickermaker';
import stickerform from './stickerform';
import navigation from './navigation';
import scroll from './scroll';
import sliders from './sliders';
import blocks from './blocks';
import preconfigurator from './preconfigurator';
import checkout from './checkout';
import singleProduct from './single-product';
import customOt from './custom-ot';
import m2stickers from './m2stickers';

jQuery(document).ready(function () {

    stickermaker();
    stickerform();
    navigation();

    // scroll() returns the Lenis instance; the preconfigurator popups pause/resume it
    const lenis = scroll();

    sliders();
    blocks();
    preconfigurator(lenis);
    checkout();
    singleProduct();
    customOt();
    m2stickers();

});
